import DialogTitle from '@mui/material/DialogTitle';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import { useAppDispatch, useAppSelector } from '@/store/hooks/redux';
import { setMediaLibraryDrawerState } from '../../store/reducers/modals-drawers.slice';
import MediaLibraryWrapper from './MediaLibraryWrapper';
import ClearTwoToneIcon from '@mui/icons-material/ClearTwoTone';

import type { FC, JSX } from 'react';

const MediaLibraryDrawer: FC = (): JSX.Element => {
  const { mediaLibraryDrawerState } = useAppSelector((state) => state.editorModalsDrawersReducer);

  const dispatch = useAppDispatch();
  const handleCloseDrawer = () => {
    dispatch(
      setMediaLibraryDrawerState({
        isOpened: false,
        creativeType: null,
        carouselItemIndex: undefined,
        platform: null,
      })
    );
  };

  return (
    <Drawer
      anchor="right"
      open={mediaLibraryDrawerState.isOpened}
      onClose={handleCloseDrawer}
      PaperProps={{ sx: { width: { xs: '100%', sm: '80%', md: '80%' } } }}>
      <DialogTitle sx={{ p: 0, display: 'flex', justifyContent: 'flex-end' }}>
        <IconButton onClick={handleCloseDrawer}>
          <ClearTwoToneIcon />
        </IconButton>
      </DialogTitle>
      <MediaLibraryWrapper></MediaLibraryWrapper>
    </Drawer>
  );
};

export default MediaLibraryDrawer;
